// ======================================================================
// File Name       : SuperUserContants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

// SelectBox data
export const SUPERUSER_SORT_TYPE = {
  superuserName: 0,
  loginId: 1,
  enterpriseName: 2,
  lockState: 3,
};

// Step10.0.0 START
export const SUPERUSER_TYPE = {
  rootUser: "root",
  normalUser: "通常",
};

export const KEY_ROLE_TYPE = {
  ROLE_OPTIONS: 'roleOptions',
  BATCH_ROLE_OPTIONS: 'batchRoleOptions',
};
// Step10.0.0 END
